import React from "react";
import myImg from "../../assets/developer.png";
import { Container } from "react-bootstrap";
import TypeWriter from "./TypeWriter";
import "./Home.css";
import VerticalTimeLine from "./VerticalTimeLine";

function Home() {
  return (
    // <div>
    <Container className="home-section">
      <div className="home-content">
        <div className="home-header">
          <h1 style={{ paddingBottom: 15 }} className="heading">
            Hi There!{" "}
            <span className="wave" role="img" aria-labelledby="wave">
              👋🏻
            </span>
          </h1>

          <h1 className="heading-name">
            I'M
            <strong className="main-name !text-blue-950"> Sabal</strong>
          </h1>

          <p className="heading-description blockquote">
            Bridging creativity and technology, I craft seamless user
            experiences with Java, JavaScript, and cutting-edge
            innovations—because great software isn’t just built, it’s designed
            to inspire.
          </p>

          <div className="heading-type">
            <TypeWriter />
          </div>
        </div>
        <div className="home-profile">
          <div class="profile-frame">
            <img src={myImg} alt="Profile" />
          </div>
        </div>
      </div>
      <div className="" style={{ position: "relative" }}>
        <VerticalTimeLine />
      </div>
    </Container>
    // </div>
  );
}

export default Home;
